<template>
  <div>
    <v-dialog
      v-model="dialogApplication"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-divider></v-divider>
        <v-row >
          <v-col cols="6" v-if="datas.positionStatus === 'ว่าง'">
            <v-btn
              :color="colorApplication"
              dark
              v-bind="attrs"
              v-on="on"
              @click="getDataApplicationFormByID(datas.positionCode)"
            >
              สร้างใบสมัครงาน
              <v-icon dark right> mdi-account-circle </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogApplication = false, getDataApplicationFormByID(datas.positionCode)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>สร้างใบสมัครงาน</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>ตำแหน่งาน</v-subheader>
          <v-row>
            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>positionCode</v-list-item-title>
                  <v-list-item-subtitle>{{
                    datas.positionCode
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>positionName</v-list-item-title>
                  <v-list-item-subtitle>{{
                    datas.positionName
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>positionTypeName</v-list-item-title>
                  <v-list-item-subtitle>{{
                    datas.positionTypeName
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>masDepartmentName</v-list-item-title>
                  <v-list-item-subtitle>{{
                    datas.masDepartmentName
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>masBranchName</v-list-item-title>
                  <v-list-item-subtitle>{{
                    datas.masBranchName
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="4">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>masCompanyName</v-list-item-title>
                  <v-list-item-subtitle>{{
                    datas.masCompanyName
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>รายละเอียดตำแหน่งงาน</v-subheader>
          <v-list-item>
            <v-list-item-content>
              <vue-editor v-model="datas.positionJobDescription"></vue-editor>
              <v-list-item-subtitle
                >*รายละเอียดงานแสดงผลในหน้าสมัครงาน</v-list-item-subtitle
              >
              <v-list-item-subtitle>
                <v-btn color="primary" dark @click.stop="updateJD(selection2)">
                  ปรับปรุงรายละเอียด
                  <v-icon dark right> mdi-checkbox-marked-circle </v-icon>
                </v-btn></v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-content>
              <v-row align="center" justify="center">
                <v-col cols="4">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formUpdateItemApplication.EXPIRY_DATE"
                        label="วันที่ปิดรับสมัคร"
                        locale="TH"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formUpdateItemApplication.EXPIRY_DATE"
                      no-title
                      locale="TH"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="
                          $refs.menu.save(formUpdateItemApplication.EXPIRY_DATE)
                        "
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4">
                  <v-switch
                    style="margin-top: 0px"
                    v-model="formUpdateItemApplication.appLinkStatus"
                    inset
                    label="สถานะเปิดรับสมัคร"
                  ></v-switch>
                </v-col>
                <v-col cols="4" v-if="!chackUpdateDelete">
                  <v-btn
                    color="success"
                    dark
                    @click.stop="submitAddApplication(formUpdateItemApplication)"
                    style="margin-top: -20px"
                  >
                    ใช้งาน
                    <v-icon dark right> mdi-checkbox-marked-circle </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="4" v-if="chackUpdateDelete">
                  <v-btn
                    color="info"
                    dark
                    @click.stop="editDataApp(formUpdateItemApplication)"
                    style="margin-top: -20px"
                  >
                    ปรับปรุง
                    <v-icon dark right> mdi-tools </v-icon>
                  </v-btn>
                  <v-btn
                    color="red"
                    dark
                    @click.stop="deleteDataApp(formUpdateItemApplication)"
                    style="margin-top: -20px"
                  >
                    ลบ
                    <v-icon dark right> mdi-delete </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- <v-divider></v-divider>
         <v-list three-line subheader>
          <v-subheader>จำนวนผู้สมัครตำแหน่ง {{datas.positionName}}</v-subheader>
          <v-card>
          <v-data-table
            :headers="headers"
            :items="desserts"
            :items-per-page="10"
            class="elevation-1"
          ></v-data-table>
          </v-card>
        </v-list> -->

      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { VueEditor } from 'vue2-editor'
import moment from 'moment' // แปลง date

export default {
  name: 'ApplicationForm',
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    VueEditor,
    readXlsxFile
  },
  props: {
    sessionData: '',
    datas: {}
  },
  data () {
    return {
      active: [],
      PK: '',
      path: '/pos_position/',
      date: new Date().toISOString().substr(0, 10),
      dialogApplication: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'PT_', // Generate Code
      switch1: true,
      formUpdateItemApplicationJobDescription: {
        positionJobDescription: ''
      },
      formUpdateItemApplication: {
        EXPIRY_DATE: '',
        appLinkStatus: false
      },
      chackUpdateDelete: false,
      chackAddEmployee: false,
      colorApplication: 'success',
      Employee: [],
      EmployeeID: '',
      formUpdateEmployee: {
        positionCode: '',
        empId: ''
      }
    }
  },
  async mounted () {
    this.chackAddEmployee = true
    await this.getDataApplicationFormByID(this.datas.positionCode)
    await this.getDataEmployee()
  },
  methods: {
    async getDataApplicationFormByID (dt) {
      this.colorApplication = 'success'
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/application_link_position/' +
            'getPositionCode?positionCode=' +
            dt,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          response.data.appLinkStatus = response.data.appLinkStatus === 'True'
          response.data.EXPIRY_DATE = moment(
            String(response.data.EXPIRY_DATE)
          ).format('YYYY-MM-DD')
          this.formUpdateItemApplication = response.data
          this.chackUpdateDelete = true
          console.log(response.data)
          if (response.data.appLinkStatus === true) {
            this.colorApplication = 'warning'
            this.chackAddEmployee = false
          }

          console.log('getDataApplicationFormByID : ', response)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.colorApplication = 'success'
          this.chackAddEmployee = true
          this.chackUpdateDelete = false
          console.log(error)
        })
    },
    submitAddApplication (dt) {
      dt.appLinkCode = this.generateCodeGlobal()
      dt.CREATE_USER = this.$session.getAll().data.userName
      dt.LAST_USER = this.$session.getAll().data.userName
      dt.positionCode = this.datas.positionCode
      dt.EXPIRY_DATE = moment(String(dt.EXPIRY_DATE)).format('YYYY-MM-DD')
      delete dt['appLinkId']
      delete dt['LAST_DATE']
      delete dt['CREATE_DATE']
      delete dt['RECORD_STATUS']
      if (dt.EXPIRY_DATE === '' || dt.EXPIRY_DATE === null) {
        this.$swal('ผิดพลาด', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'error')
      } else {
        this.submitAddApplicationApprove(this.DNS_IP, dt)
      }
    },
    async submitAddApplicationApprove (DNS_IP, DT) {
      this.$swal({
        title: 'ต้องการ เริ่มต้นสร้างใบสมัคร ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + "/application_link_position/add",
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              console.log('success function submitAddApplicationApprove : ', response)
              this.dialogApplication = false
              if (DT.appLinkStatus === true) {
                this.colorApplication = 'warning'
                this.chackAddEmployee = false
              } else {
                this.colorApplication = 'success'
                this.chackAddEmployee = true
              }
            })
            .catch((error) => {
              console.log('error function submitAddApplicationApprove : ', error)
            })
        })
        .catch((error) => {
          console.log('error function submitAddApplicationApprove : ', error)
        })
    },
    async updateJD () {
      // Config User ทำรายการล่าสุด
      this.formUpdateItemApplicationJobDescription.LAST_USER = this.$session.getAll().data.userName
      this.formUpdateItemApplicationJobDescription.positionJobDescription = this.item.positionJobDescription
      console.log(this.formUpdateItemApplicationJobDescription)

      if (
        this.formUpdateItemApplicationJobDescription.positionJobDescription === '' ||
        this.formUpdateItemApplicationJobDescription.positionJobDescription === null
      ) {
        this.$swal('ผิดพลาด', 'กรุณากรอกข้อมูลให้ครบถ้วน', 'error')
      } else {
        this.dataReady = false
        this.submitEditJD(
          this.DNS_IP,
          this.path,
          this.item.positionID,
          this.formUpdateItemApplicationJobDescription
        )
      }
    },
    async submitEditJD (DNS_IP, PATH, ID, DT) {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItemApplicationJobDescription)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + PATH + "edit/" + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              // if (DT.appLinkStatus === true) {
              //   this.colorApplication = 'warning'
              // } else {
              //   this.colorApplication = 'success'
              // }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          console.log('error function editDataGlobal : ', error)
        })
    },
    async editDataApp (dt) {
      // Config User ทำรายการล่าสุด
      dt.LAST_USER = this.$session.getAll().data.userName
      dt.positionCode = this.datas.positionCode
      var pk = dt['appLinkId']
      delete dt['appLinkId']
      delete dt['LAST_DATE']
      delete dt['CREATE_DATE']
      delete dt['RECORD_STATUS']
      delete dt['CREATE_USER']
      // End Config User ทำรายการล่าสุด

      // this.dataReady = false
      this.editDataApplicationForm(this.DNS_IP, pk, dt)

      console.log(this.formUpdateItemApplication)
    },
    async editDataApplicationForm (DNS_IP, ID, DT) {
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + "/application_link_position/" + "edit/" + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              if (DT.appLinkStatus === true) {
                this.colorApplication = 'warning'
                this.chackAddEmployee = false
              } else {
                this.colorApplication = 'success'
                this.chackAddEmployee = true
              }
              this.dialogApplication = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteDataApp (dt) {
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      dt.LAST_USER = this.$session.getAll().data.userName
      console.log(dt)

      this.deleteDataApplicationForm(this.DNS_IP, dt.appLinkId, dt)
    },
    async deleteDataApplicationForm (DNS_IP, ID, DT) {
      this.$swal({
        title: 'ต้องการ ลบข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#fa0202',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          await axios
            .post(
              // eslint-disable-next-line quotes
              DNS_IP + "/application_link_position/" + "delete/" + ID,
              DT,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              this.colorApplication = 'success'
              this.dialogApplication = false
              this.chackAddEmployee = true
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              this.$swal('ผิดพลาด', 'ผิดพลาด -1', 'error')
              console.log('error function deleteDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          this.$swal('ผิดพลาด', 'ผิดพลาด -2', 'error')
          console.log('error function deleteDataGlobal : ', error)
        })
    },
    // Employee
    async getDataEmployee () {
      // Clear Data ทุกครั้ง
      this.Employee = []
      /// / // console.log('Branch')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/" + "getEmp?positionCode_is_null=T",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.empId
            s.text =
              d.empTitle_NameTH +
              ' ' +
              d.empFirst_NameTH +
              ' ' +
              d.empLast_NameTH
            d = s
            this.Employee.push(d)
          }
          // console.log('Employee : ', this.Employee)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // // console.log(error)
        })
    },
    async updateEmployee (dt) {
      if (this.EmployeeID) {
        this.dataReady = false
        console.log(dt.positionCode)

        // Config User ทำรายการล่าสุด
        this.formUpdateEmployee.LAST_USER = this.$session.getAll().data.userName
        this.formUpdateEmployee.positionCode = dt.positionCode
        // End Config User ทำรายการล่าสุด

        // Debug
        console.log('EDIT PK : ', this.PK)
        console.log('formUpdateItemApplicationJobDescription', JSON.stringify(this.formUpdateEmployee))

        this.$swal({
          title: 'ต้องการ เชื่อมต่อ ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async (result) => {
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + "/employee/edit/" + this.EmployeeID,
                this.formUpdateEmployee,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async (response) => {
                // Debug response
                this.Employee = []
                this.datas = []

                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogEdit = false

                // Load Data
                await this.reloadData()
                await this.getData(this.DNS_IP, this.path)
              })
              // eslint-disable-next-line handle-callback-err
              .catch((error) => {
                this.dataReady = true
                console.log('error function editDataGlobal : ', error)
              })
          })
          .catch((error) => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาเลือกบุคคล', 'error')
      }
    },
    async deleteEmployee (dt) {
      if (this.EmployeeID) {
        // Config User ทำรายการล่าสุด
        this.formUpdateEmployee.LAST_USER = this.$session.getAll().data.userName
        this.formUpdateEmployee.positionCode = dt.positionCode
        // End Config User ทำรายการล่าสุด

        // Debug
        console.log('EDIT PK : ', this.PK)
        console.log('formUpdateItemApplicationJobDescription', JSON.stringify(this.formUpdateEmployee))

        this.$swal({
          title: 'ต้องการ เชื่อมต่อ ใช่หรือไม่?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่'
        })
          .then(async (result) => {
            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + "/employee/updatePostionDelete/" + this.EmployeeID,
                this.formUpdateEmployee,
                {
                  headers: {
                    'Application-Key': this.$session.getAll().ApplicationKey
                  }
                }
              )
              .then(async (response) => {
                // Debug response
                this.Employee = []
                this.datas = []

                console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

                this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogEdit = false

                // Load Data
                await this.reloadData()
                await this.getData(this.DNS_IP, this.path)
              })
              // eslint-disable-next-line handle-callback-err
              .catch((error) => {
                this.dataReady = true
                console.log('error function editDataGlobal : ', error)
              })
          })
          .catch((error) => {
            this.dataReady = true
            console.log('error function editDataGlobal : ', error)
          })
      } else {
        this.$swal('ผิดพลาด', 'กรุณาเลือกบุคคล', 'error')
      }
    }
  }
}
</script>
<style scope>
</style>



// WEBPACK FOOTER //
// src/components/HRM/Pos/PositionApplication.vue